import React from "react";
import { Link } from "react-router-dom";
import { Hash, Twitter, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-yellow-400 flex items-center justify-center">
              <Hash className="w-4 h-4 text-black" strokeWidth={3} />
            </div>
            <span className="font-display font-bold text-xl text-white">HashRate</span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Real-time crypto intelligence and a high-signal community.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Sections</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/news">News</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories">Categories</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/community">Community</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Categories</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/bitcoin">Bitcoin</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/ethereum">Ethereum</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/altcoins">Altcoins</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/market-analysis">Market Analysis</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Connect</h4>
          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition">
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex justify-between items-center text-xs font-mono text-zinc-500">
          <span>© {new Date().getFullYear()} HashRate. All rights reserved.</span>
          <span>Built for signal, not noise.</span>
        </div>
      </div>
    </footer>
  );
}
